import { getConfig } from "@jti/fe-common";
import { getUser } from "@jti/rest-api";
import { MagentoApi } from "../MagentoApi/MagentoApi";
import { ClientGraphQL } from "./ClientGraphQL";
const getGqlClient = ({ isTrial = false, useGet = false, config = getConfig(), } = {}) => {
    const options = {};
    const user = getUser();
    if (useGet) {
        options.method = "GET";
    }
    options.jsonSerializer = JSON; // https://github.com/jasonkuhrt/graphql-request/issues/354
    const headers = {
        Store: isTrial ? config["trials-store-view"] : config["default-store-view"],
    };
    if (user === null || user === void 0 ? void 0 : user.magento_token) {
        headers.Authorization = `Bearer ${user.magento_token}`;
    }
    options.headers = headers;
    return new ClientGraphQL(config.MAGENTO_SERVICE_URL, options);
};
const client = getGqlClient();
const getClient = getGqlClient({ useGet: true });
export const magento = new MagentoApi(client, getClient);
const trialClient = getGqlClient({ isTrial: true });
const trialGetClient = getGqlClient({ isTrial: true, useGet: true });
export const trialMagento = new MagentoApi(trialClient, trialGetClient);
export const getCurrentMagentoClient = (isTrial = false) => (isTrial ? trialMagento : magento);
export const createMagentoClient = ({ isTrial = false, config, }) => {
    const client = getGqlClient({ isTrial, config });
    const getClient = getGqlClient({ isTrial, useGet: true, config });
    return new MagentoApi(client, getClient);
};
//# sourceMappingURL=getClient.js.map